<div mat-dialog-title>
  <span>{{'subscriptions.modal.assignment.title' | translate}}</span>
</div>
@if (loadingState | async; as state) {
  <div class="subscription__ctn">
    <mat-dialog-content>
      @if (state === actionState.READY) {
        <p class="label">{{'subscriptions.modal.assignment.subscription_list_message' | translate}}</p>
        <ul>
          @for (sub of subList; track sub; let isFirst = $first) {
            <li>
              <input type="radio" class="form-control" id="sub.uid" [checked]="isFirst"
                (change)="selectedSubUid === sub.uid">
              <label [htmlFor]="sub.uid">{{sub.displayName}}</label>
            </li>
          }
        </ul>
        <div class="text-center mt-20">
          <button class="btn btn--primary" (click)="onSubmit()">{{'action.submit' | translate}}</button>
          <button mat-dialog-close class="btn btn--outline-grey-color ml-20" type="button">{{'action.cancel' | translate}}</button>
        </div>
      }
      @if (state === actionState.SUCCESS) {
        <div class="alert alert-success font-size-normal text-center">
          {{'subscriptions.modal.assignment.message.success' | translate }}
        </div>
        <div class="mt-20 text-center">
          <button class="btn btn--primary"
          [mat-dialog-close]="actionState.SUCCESS">{{'action.close' | translate}}</button>
        </div>
      }
      @if (state === actionState.FAILED) {
        <div class="app-display-errors-message" [error]="error"></div>
        <div class="mt-20 text-center">
          <button mat-dialog-close class="btn btn--outline-grey-color">{{'action.cancel' | translate}}</button>
        </div>
      }
      @if (state === actionState.LOADING) {
        <span class="ui-loading" [model]="{isLoading: true}"></span>
      }
    </mat-dialog-content>
  </div>
}